import {
  searchByName,
  deleteObj,
  modifyObj,
  getDetail,
  getAll,
  getPage,
  addObj,
  uploadPositioningDeviceInfosFile,
  quicklyGenerateVideoCertificateForYILIU,
  generateMergencyAlarmCertificate,
  quicklyGenerateInsuranceVideoCommitment,
  getMyPositioningdeviceinfoForUnbindTerminalnum,
  generateInsuranceVideoCommitment,
  quicklyGenerateVideoCertificate,
  quicklyGenerateCertificateForYILIU,
  modifyPositioningDeviceInfosFile,
  generateVideoCertificateForYILIU,
  generateMergencyAlarmCertificateForYILIU,
  exportExcel,
  bindSimInfos,
  unBindSimInfos,
  reopeningState,
  changeInstaller,
  batchChangeInstaller,
  generateVideoCommitment,
  generateStarLightAlarmForYILIU,
  bindTerminalnum,
  generateVideoCertificate,
  generateCertificate,
  quicklyGenerateCertificate,
  unBindTerminalnum,
  getTerminalnumForManufacturer,
  modifyServiceDatetime,
  bindPositioningDeviceFittings,
  generateCertificateForYILIU,
  getMyPositioningdeviceinfo,
  supplementaryRenewalOrder,
} from '@/api/positioningdeviceinfoserv'

export default {
  state: {
    state_PositioningDeviceInfo_SearchByNameResult: null,
    state_PositioningDeviceInfo_DeleteObjResult: null,
    state_PositioningDeviceInfo_ModifyObjResult: null,
    state_PositioningDeviceInfo_GetDetailResult: null,
    state_PositioningDeviceInfo_GetAllResult: null,
    state_PositioningDeviceInfo_GetPageResult: null,
    state_PositioningDeviceInfo_AddObjResult: null,
    state_PositioningDeviceInfo_UploadPositioningDeviceInfosFileResult: null,
    state_PositioningDeviceInfo_QuicklyGenerateVideoCertificateForYILIUResult: null,
    state_PositioningDeviceInfo_GenerateMergencyAlarmCertificateResult: null,
    state_PositioningDeviceInfo_QuicklyGenerateInsuranceVideoCommitmentResult: null,
    state_PositioningDeviceInfo_GetMyPositioningdeviceinfoForUnbindTerminalnumResult: null,
    state_PositioningDeviceInfo_GenerateInsuranceVideoCommitmentResult: null,
    state_PositioningDeviceInfo_QuicklyGenerateVideoCertificateResult: null,
    state_PositioningDeviceInfo_QuicklyGenerateCertificateForYILIUResult: null,
    state_PositioningDeviceInfo_ModifyPositioningDeviceInfosFileResult: null,
    state_PositioningDeviceInfo_GenerateVideoCertificateForYILIUResult: null,
    state_PositioningDeviceInfo_GenerateMergencyAlarmCertificateForYILIUResult: null,
    state_PositioningDeviceInfo_ExportExcelResult: null,
    state_PositioningDeviceInfo_BindSimInfosResult: null,
    state_PositioningDeviceInfo_UnBindSimInfosResult: null,
    state_PositioningDeviceInfo_ReopeningStateResult: null,
    state_PositioningDeviceInfo_ChangeInstallerResult: null,
    state_PositioningDeviceInfo_BatchChangeInstallerResult: null,
    state_PositioningDeviceInfo_GenerateVideoCommitmentResult: null,
    state_PositioningDeviceInfo_GenerateStarLightAlarmForYILIUResult: null,
    state_PositioningDeviceInfo_BindTerminalnumResult: null,
    state_PositioningDeviceInfo_GenerateVideoCertificateResult: null,
    state_PositioningDeviceInfo_GenerateCertificateResult: null,
    state_PositioningDeviceInfo_QuicklyGenerateCertificateResult: null,
    state_PositioningDeviceInfo_UnBindTerminalnumResult: null,
    state_PositioningDeviceInfo_GetTerminalnumForManufacturerResult: null,
    state_PositioningDeviceInfo_ModifyServiceDatetimeResult: null,
    state_PositioningDeviceInfo_BindPositioningDeviceFittingsResult: null,
    state_PositioningDeviceInfo_GenerateCertificateForYILIUResult: null,
    state_PositioningDeviceInfo_GetMyPositioningdeviceinfoResult: null,
    state_PositioningDeviceInfo_SupplementaryRenewalOrderResult: null,
  },
  mutations: {
    SET_POSITIONINGDEVICEINFO_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_SearchByNameResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_DELETEOBJ_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_DeleteObjResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_ModifyObjResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_GETDETAIL_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_GetDetailResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_GETALL_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_GetAllResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_GETPAGE_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_GetPageResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_ADDOBJ_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_AddObjResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_UPLOADPOSITIONINGDEVICEINFOSFILE_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_UploadPositioningDeviceInfosFileResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_QUICKLYGENERATEVIDEOCERTIFICATEFORYILIU_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_QuicklyGenerateVideoCertificateForYILIUResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_GENERATEMERGENCYALARMCERTIFICATE_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_GenerateMergencyAlarmCertificateResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_QUICKLYGENERATEINSURANCEVIDEOCOMMITMENT_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_QuicklyGenerateInsuranceVideoCommitmentResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_GETMYPOSITIONINGDEVICEINFOFORUNBINDTERMINALNUM_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_GetMyPositioningdeviceinfoForUnbindTerminalnumResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_GENERATEINSURANCEVIDEOCOMMITMENT_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_GenerateInsuranceVideoCommitmentResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_QUICKLYGENERATEVIDEOCERTIFICATE_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_QuicklyGenerateVideoCertificateResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_QUICKLYGENERATECERTIFICATEFORYILIU_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_QuicklyGenerateCertificateForYILIUResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_MODIFYPOSITIONINGDEVICEINFOSFILE_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_ModifyPositioningDeviceInfosFileResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_GENERATEVIDEOCERTIFICATEFORYILIU_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_GenerateVideoCertificateForYILIUResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_GENERATEMERGENCYALARMCERTIFICATEFORYILIU_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_GenerateMergencyAlarmCertificateForYILIUResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_ExportExcelResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_BINDSIMINFOS_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_BindSimInfosResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_UNBINDSIMINFOS_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_UnBindSimInfosResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_REOPENINGSTATE_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_ReopeningStateResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_CHANGEINSTALLER_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_ChangeInstallerResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_BATCHCHANGEINSTALLER_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_BatchChangeInstallerResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_GENERATEVIDEOCOMMITMENT_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_GenerateVideoCommitmentResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_GENERATESTARLIGHTALARMFORYILIU_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_GenerateStarLightAlarmForYILIUResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_BINDTERMINALNUM_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_BindTerminalnumResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_GENERATEVIDEOCERTIFICATE_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_GenerateVideoCertificateResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_GENERATECERTIFICATE_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_GenerateCertificateResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_QUICKLYGENERATECERTIFICATE_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_QuicklyGenerateCertificateResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_UNBINDTERMINALNUM_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_UnBindTerminalnumResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_GETTERMINALNUMFORMANUFACTURER_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_GetTerminalnumForManufacturerResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_MODIFYSERVICEDATETIME_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_ModifyServiceDatetimeResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_BINDPOSITIONINGDEVICEFITTINGS_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_BindPositioningDeviceFittingsResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_GENERATECERTIFICATEFORYILIU_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_GenerateCertificateForYILIUResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_GETMYPOSITIONINGDEVICEINFO_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_GetMyPositioningdeviceinfoResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_SUPPLEMENTARYRENEWALORDER_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_SupplementaryRenewalOrderResult = rst;
    },
  },
  actions: {
    PositioningDeviceInfoServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_UploadPositioningDeviceInfosFile({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        uploadPositioningDeviceInfosFile(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_UPLOADPOSITIONINGDEVICEINFOSFILE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_UPLOADPOSITIONINGDEVICEINFOSFILE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_QuicklyGenerateVideoCertificateForYILIU({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        quicklyGenerateVideoCertificateForYILIU(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_QUICKLYGENERATEVIDEOCERTIFICATEFORYILIU_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_QUICKLYGENERATEVIDEOCERTIFICATEFORYILIU_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_GenerateMergencyAlarmCertificate({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        generateMergencyAlarmCertificate(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_GENERATEMERGENCYALARMCERTIFICATE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_GENERATEMERGENCYALARMCERTIFICATE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_QuicklyGenerateInsuranceVideoCommitment({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        quicklyGenerateInsuranceVideoCommitment(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_QUICKLYGENERATEINSURANCEVIDEOCOMMITMENT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_QUICKLYGENERATEINSURANCEVIDEOCOMMITMENT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_GetMyPositioningdeviceinfoForUnbindTerminalnum({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyPositioningdeviceinfoForUnbindTerminalnum(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_GETMYPOSITIONINGDEVICEINFOFORUNBINDTERMINALNUM_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_GETMYPOSITIONINGDEVICEINFOFORUNBINDTERMINALNUM_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_GenerateInsuranceVideoCommitment({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        generateInsuranceVideoCommitment(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_GENERATEINSURANCEVIDEOCOMMITMENT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_GENERATEINSURANCEVIDEOCOMMITMENT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_QuicklyGenerateVideoCertificate({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        quicklyGenerateVideoCertificate(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_QUICKLYGENERATEVIDEOCERTIFICATE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_QUICKLYGENERATEVIDEOCERTIFICATE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_QuicklyGenerateCertificateForYILIU({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        quicklyGenerateCertificateForYILIU(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_QUICKLYGENERATECERTIFICATEFORYILIU_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_QUICKLYGENERATECERTIFICATEFORYILIU_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_ModifyPositioningDeviceInfosFile({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyPositioningDeviceInfosFile(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_MODIFYPOSITIONINGDEVICEINFOSFILE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_MODIFYPOSITIONINGDEVICEINFOSFILE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_GenerateVideoCertificateForYILIU({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        generateVideoCertificateForYILIU(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_GENERATEVIDEOCERTIFICATEFORYILIU_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_GENERATEVIDEOCERTIFICATEFORYILIU_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_GenerateMergencyAlarmCertificateForYILIU({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        generateMergencyAlarmCertificateForYILIU(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_GENERATEMERGENCYALARMCERTIFICATEFORYILIU_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_GENERATEMERGENCYALARMCERTIFICATEFORYILIU_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_BindSimInfos({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        bindSimInfos(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_BINDSIMINFOS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_BINDSIMINFOS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_UnBindSimInfos({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        unBindSimInfos(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_UNBINDSIMINFOS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_UNBINDSIMINFOS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_ReopeningState({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        reopeningState(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_REOPENINGSTATE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_REOPENINGSTATE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_ChangeInstaller({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        changeInstaller(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_CHANGEINSTALLER_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_CHANGEINSTALLER_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_BatchChangeInstaller({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        batchChangeInstaller(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_BATCHCHANGEINSTALLER_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_BATCHCHANGEINSTALLER_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_GenerateVideoCommitment({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        generateVideoCommitment(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_GENERATEVIDEOCOMMITMENT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_GENERATEVIDEOCOMMITMENT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_GenerateStarLightAlarmForYILIU({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        generateStarLightAlarmForYILIU(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_GENERATESTARLIGHTALARMFORYILIU_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_GENERATESTARLIGHTALARMFORYILIU_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_BindTerminalnum({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        bindTerminalnum(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_BINDTERMINALNUM_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_BINDTERMINALNUM_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_GenerateVideoCertificate({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        generateVideoCertificate(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_GENERATEVIDEOCERTIFICATE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_GENERATEVIDEOCERTIFICATE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_GenerateCertificate({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        generateCertificate(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_GENERATECERTIFICATE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_GENERATECERTIFICATE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_QuicklyGenerateCertificate({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        quicklyGenerateCertificate(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_QUICKLYGENERATECERTIFICATE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_QUICKLYGENERATECERTIFICATE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_UnBindTerminalnum({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        unBindTerminalnum(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_UNBINDTERMINALNUM_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_UNBINDTERMINALNUM_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_GetTerminalnumForManufacturer({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getTerminalnumForManufacturer(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_GETTERMINALNUMFORMANUFACTURER_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_GETTERMINALNUMFORMANUFACTURER_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_ModifyServiceDatetime({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyServiceDatetime(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_MODIFYSERVICEDATETIME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_MODIFYSERVICEDATETIME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_BindPositioningDeviceFittings({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        bindPositioningDeviceFittings(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_BINDPOSITIONINGDEVICEFITTINGS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_BINDPOSITIONINGDEVICEFITTINGS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_GenerateCertificateForYILIU({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        generateCertificateForYILIU(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_GENERATECERTIFICATEFORYILIU_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_GENERATECERTIFICATEFORYILIU_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_GetMyPositioningdeviceinfo({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyPositioningdeviceinfo(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_GETMYPOSITIONINGDEVICEINFO_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_GETMYPOSITIONINGDEVICEINFO_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_SupplementaryRenewalOrder({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        supplementaryRenewalOrder(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_SUPPLEMENTARYRENEWALORDER_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_SUPPLEMENTARYRENEWALORDER_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_PositioningDeviceInfo_SearchByNameResult: state => {
      return state.state_PositioningDeviceInfo_SearchByNameResult;
    },
    get_PositioningDeviceInfo_DeleteObjResult: state => {
      return state.state_PositioningDeviceInfo_DeleteObjResult;
    },
    get_PositioningDeviceInfo_ModifyObjResult: state => {
      return state.state_PositioningDeviceInfo_ModifyObjResult;
    },
    get_PositioningDeviceInfo_GetDetailResult: state => {
      return state.state_PositioningDeviceInfo_GetDetailResult;
    },
    get_PositioningDeviceInfo_GetAllResult: state => {
      return state.state_PositioningDeviceInfo_GetAllResult;
    },
    get_PositioningDeviceInfo_GetPageResult: state => {
      return state.state_PositioningDeviceInfo_GetPageResult;
    },
    get_PositioningDeviceInfo_AddObjResult: state => {
      return state.state_PositioningDeviceInfo_AddObjResult;
    },
    get_PositioningDeviceInfo_UploadPositioningDeviceInfosFileResult: state => {
      return state.state_PositioningDeviceInfo_UploadPositioningDeviceInfosFileResult;
    },
    get_PositioningDeviceInfo_QuicklyGenerateVideoCertificateForYILIUResult: state => {
      return state.state_PositioningDeviceInfo_QuicklyGenerateVideoCertificateForYILIUResult;
    },
    get_PositioningDeviceInfo_GenerateMergencyAlarmCertificateResult: state => {
      return state.state_PositioningDeviceInfo_GenerateMergencyAlarmCertificateResult;
    },
    get_PositioningDeviceInfo_QuicklyGenerateInsuranceVideoCommitmentResult: state => {
      return state.state_PositioningDeviceInfo_QuicklyGenerateInsuranceVideoCommitmentResult;
    },
    get_PositioningDeviceInfo_GetMyPositioningdeviceinfoForUnbindTerminalnumResult: state => {
      return state.state_PositioningDeviceInfo_GetMyPositioningdeviceinfoForUnbindTerminalnumResult;
    },
    get_PositioningDeviceInfo_GenerateInsuranceVideoCommitmentResult: state => {
      return state.state_PositioningDeviceInfo_GenerateInsuranceVideoCommitmentResult;
    },
    get_PositioningDeviceInfo_QuicklyGenerateVideoCertificateResult: state => {
      return state.state_PositioningDeviceInfo_QuicklyGenerateVideoCertificateResult;
    },
    get_PositioningDeviceInfo_QuicklyGenerateCertificateForYILIUResult: state => {
      return state.state_PositioningDeviceInfo_QuicklyGenerateCertificateForYILIUResult;
    },
    get_PositioningDeviceInfo_ModifyPositioningDeviceInfosFileResult: state => {
      return state.state_PositioningDeviceInfo_ModifyPositioningDeviceInfosFileResult;
    },
    get_PositioningDeviceInfo_GenerateVideoCertificateForYILIUResult: state => {
      return state.state_PositioningDeviceInfo_GenerateVideoCertificateForYILIUResult;
    },
    get_PositioningDeviceInfo_GenerateMergencyAlarmCertificateForYILIUResult: state => {
      return state.state_PositioningDeviceInfo_GenerateMergencyAlarmCertificateForYILIUResult;
    },
    get_PositioningDeviceInfo_ExportExcelResult: state => {
      return state.state_PositioningDeviceInfo_ExportExcelResult;
    },
    get_PositioningDeviceInfo_BindSimInfosResult: state => {
      return state.state_PositioningDeviceInfo_BindSimInfosResult;
    },
    get_PositioningDeviceInfo_UnBindSimInfosResult: state => {
      return state.state_PositioningDeviceInfo_UnBindSimInfosResult;
    },
    get_PositioningDeviceInfo_ReopeningStateResult: state => {
      return state.state_PositioningDeviceInfo_ReopeningStateResult;
    },
    get_PositioningDeviceInfo_ChangeInstallerResult: state => {
      return state.state_PositioningDeviceInfo_ChangeInstallerResult;
    },
    get_PositioningDeviceInfo_BatchChangeInstallerResult: state => {
      return state.state_PositioningDeviceInfo_BatchChangeInstallerResult;
    },
    get_PositioningDeviceInfo_GenerateVideoCommitmentResult: state => {
      return state.state_PositioningDeviceInfo_GenerateVideoCommitmentResult;
    },
    get_PositioningDeviceInfo_GenerateStarLightAlarmForYILIUResult: state => {
      return state.state_PositioningDeviceInfo_GenerateStarLightAlarmForYILIUResult;
    },
    get_PositioningDeviceInfo_BindTerminalnumResult: state => {
      return state.state_PositioningDeviceInfo_BindTerminalnumResult;
    },
    get_PositioningDeviceInfo_GenerateVideoCertificateResult: state => {
      return state.state_PositioningDeviceInfo_GenerateVideoCertificateResult;
    },
    get_PositioningDeviceInfo_GenerateCertificateResult: state => {
      return state.state_PositioningDeviceInfo_GenerateCertificateResult;
    },
    get_PositioningDeviceInfo_QuicklyGenerateCertificateResult: state => {
      return state.state_PositioningDeviceInfo_QuicklyGenerateCertificateResult;
    },
    get_PositioningDeviceInfo_UnBindTerminalnumResult: state => {
      return state.state_PositioningDeviceInfo_UnBindTerminalnumResult;
    },
    get_PositioningDeviceInfo_GetTerminalnumForManufacturerResult: state => {
      return state.state_PositioningDeviceInfo_GetTerminalnumForManufacturerResult;
    },
    get_PositioningDeviceInfo_ModifyServiceDatetimeResult: state => {
      return state.state_PositioningDeviceInfo_ModifyServiceDatetimeResult;
    },
    get_PositioningDeviceInfo_BindPositioningDeviceFittingsResult: state => {
      return state.state_PositioningDeviceInfo_BindPositioningDeviceFittingsResult;
    },
    get_PositioningDeviceInfo_GenerateCertificateForYILIUResult: state => {
      return state.state_PositioningDeviceInfo_GenerateCertificateForYILIUResult;
    },
    get_PositioningDeviceInfo_GetMyPositioningdeviceinfoResult: state => {
      return state.state_PositioningDeviceInfo_GetMyPositioningdeviceinfoResult;
    },
    get_PositioningDeviceInfo_SupplementaryRenewalOrderResult: state => {
      return state.state_PositioningDeviceInfo_SupplementaryRenewalOrderResult;
    },
  }
}